module.exports = __webpack_public_path__ + "img/hidden.b09c9447.svg";